/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {MetadataWriterHost} from './src/compiler_host';
export {CodegenExtension, UserError, createBundleIndexHost, main} from './src/main';

export {default as AngularCompilerOptions} from './src/options';
export * from './src/bundler';
export * from './src/cli_options';
export * from './src/collector';
export * from './src/index_writer';
export * from './src/schema';
